import React from 'react'

import useNodeDimensions from 'hooks/use_node_dimensions'
import { FallbackWrapper, CircleWrapper, Symbol } from 'components/reusable/image/styled'

function ImageFallback({ className, width, height, br }) {
  const { dimensions, targetRef } = useNodeDimensions()

  return (
    <FallbackWrapper ref={targetRef} $width={width} $height={height} $br={br} className={`image__fallback-wrapper ${className}`}>
      <CircleWrapper className="image__fallback" $width={dimensions.width}>
        <Symbol>S</Symbol>
      </CircleWrapper>
    </FallbackWrapper>
  )
}

export default ImageFallback
